import { lazy } from 'react';

export const DpoViewPage = lazy(() => import('./ViewRecord/ViewRecord'));

export const DpoEditPage = lazy(() => import('./EditRecord/EditRecord'));

export const DpoAddPage = lazy(() => import('./AddRecord/AddRecord'));
